import { useIntl } from "react-intl";
import { AiIndicatorIcon } from "../../../common/icons/aiIndicator/AiIndicatorIcon";
import { AiIndicatorProps } from "./types";
import TooltipWithMount from "../tooltipWithMount/TooltipWithMount";

export const AiIndicator = ({ mode, className }: AiIndicatorProps) => {
	const intl = useIntl();

	if (mode === "icon-only") {
		return (
			<TooltipWithMount
				content={intl.formatMessage({ id: "AiIndicator.Tooltip" })}
				relationship="label"
			>
				<span
					className={className}
					style={{ display: "inline-flex", alignItems: "center" }}
				>
					<AiIndicatorIcon />
				</span>
			</TooltipWithMount>
		);
	}

	return (
		<span
			className={className}
			style={{ display: "flex", alignItems: "center", gap: 4 }}
		>
			<span>{intl.formatMessage({ id: "AiIndicator.Label" })}</span>
			<span style={{ display: "flex" }}><AiIndicatorIcon /></span>
		</span>
	);
};
